import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ApiService, SortDirectionFinancing } from '@lsq-frontend/angular-shared/api-service';
import { ISettings, SETTINGS } from '@lsq-frontend/angular-shared/settings';
import { Error } from '@lsq-frontend/remote-services/all-java/common-mk0';
import { FeatureFlagService } from '@lsq-frontend/common-ui';
import { ExportType } from '../models/export-type';
import {
    GetRulesRequest,
    ListRulesForAllGroupsRequest,
    SortDirection
} from '@lsq-frontend/remote-services/asap-restapi';

export class ListAsapRulesetsComparisonExportResponse {
    public ok = false;
    public fileString = '';
    public error: Error = null;
}

export class ListAsapRulesetsComparisonExportRequest {
    public fileType: string;
    public exportType: ExportType;
    public request: string;

    constructor(init?: Partial<ListAsapRulesetsComparisonExportRequest>) {
        Object.keys(init ?? {}).forEach((k) => (this[k] = init[k]));
    }
}

@Injectable({ providedIn: 'root' })
export class ListAsapRulesetsComparisonExportService extends ApiService<
    ListRulesForAllGroupsRequest,
    ListAsapRulesetsComparisonExportResponse
> {
    public requestType = ListRulesForAllGroupsRequest;
    public responseType = ListAsapRulesetsComparisonExportResponse;
    public endpointName = 'v1/asapExport';
    public serviceName = 'reportCenter';
    public usePascalForUrl = false;

    constructor(
        http: HttpClient,
        @Inject(SETTINGS) settings: ISettings,
        private _featureFlagService: FeatureFlagService
    ) {
        super(http, settings);
    }

    public requestMapper(
        req: ListRulesForAllGroupsRequest
    ): ListAsapRulesetsComparisonExportRequest {
        let sortDirection: SortDirection;
        if (
            req.pagination != null &&
            req.pagination.sortDirection == SortDirectionFinancing.DESCENDING
        ) {
            sortDirection = SortDirection.Descending;
        } else {
            sortDirection = SortDirection.Ascending;
        }

        const asapReq: GetRulesRequest = {
            pagination: {
                sortColumn: req.pagination != null ? req.pagination.sortColumn : null,
                sortDirection: sortDirection
            }
        };

        const query = JSON.stringify(asapReq);

        return {
            fileType: 'csv',
            exportType: ExportType.ASAP_RULESETS_COMPARISON,
            request: query
        };
    }

    public get endpointUrl(): string {
        return super.endpointUrl.replace('/api', '');
    }
}
